var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 162,
    viewBox: "0 0 171 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.987 48.3389C182.45 89.1381 163.2 136.679 120.991 154.525C78.7833 172.371 29.6001 153.764 11.1378 112.965C-7.32442 72.1656 11.9255 24.6242 54.1337 6.77827C96.3419 -11.0677 145.525 7.53961 163.987 48.3389Z",
    fill: "url(#paint0_linear_723_2277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3593 57.0781C57.2002 63.3546 54.2394 70.6689 47.746 73.415C41.2527 76.161 33.6858 73.299 30.8449 67.0225C28.004 60.7459 30.9648 53.4316 37.4582 50.6856C43.9515 47.9395 51.5184 50.8015 54.3593 57.0781Z",
    fill: "url(#paint1_linear_723_2277)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.295 23.1044C133.928 25.3429 133.684 28.2264 131.75 29.5449C129.815 30.8634 126.924 30.1176 125.291 27.8791C123.658 25.6407 123.902 22.7572 125.836 21.4387C127.771 20.1202 130.662 20.866 132.295 23.1044Z",
    fill: "url(#paint2_linear_723_2277)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.208 82.1852C164.747 83.0397 165.813 86.485 164.59 89.8804C163.367 93.2758 160.318 95.3356 157.779 94.4811C155.24 93.6266 154.173 90.1813 155.396 86.7859C156.619 83.3905 159.669 81.3306 162.208 82.1852Z",
    fill: "url(#paint3_linear_723_2277)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1273 2.9353C85.2912 4.31949 82.4283 5.77292 78.7328 6.18164C75.0374 6.59036 71.9088 5.79959 71.745 4.4154C71.5811 3.03121 74.444 1.57778 78.1394 1.16906C81.8349 0.760344 84.9635 1.55112 85.1273 2.9353Z",
    fill: "url(#paint4_linear_723_2277)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.436 126.978C118.229 135.999 110.706 144.978 99.6327 147.034C88.5599 149.09 78.1306 143.443 76.3382 134.422C74.5459 125.4 82.0691 116.421 93.1419 114.365C104.215 112.31 114.644 117.956 116.436 126.978Z",
    fill: "url(#paint5_linear_723_2277)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4184 3.54943C59.9748 4.65034 56.6575 7.3225 52.0089 9.51787C47.3603 11.7132 43.1408 12.6005 42.5844 11.4996C42.0279 10.3987 45.3453 7.72652 49.9938 5.53114C54.6424 3.33577 58.8619 2.44853 59.4184 3.54943Z",
    fill: "#8A0F18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1477 4.99621C61.1079 6.89593 58.1178 10.2157 53.4693 12.4111C48.8207 14.6065 44.2739 14.8462 43.3137 12.9464C42.3535 11.0467 45.3435 7.72695 49.9921 5.53155C54.6407 3.33616 59.1875 3.09648 60.1477 4.99621Z",
    fill: "#8A0F18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7573 3.77666C56.9192 4.09698 54.4112 5.6031 51.1555 7.14066C47.8998 8.67823 45.1293 9.66499 44.9674 9.34467C44.8055 9.02435 47.3135 7.51823 50.5692 5.98066C53.8249 4.4431 56.5954 3.45633 56.7573 3.77666Z",
    fill: "#480307"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25919 92.5384C3.23255 91.9575 6.82051 97.7981 9.27312 105.584C11.7257 113.369 12.1142 120.152 10.1409 120.732C8.1675 121.313 4.57954 115.473 2.12694 107.687C-0.325671 99.9015 -0.714175 93.1192 1.25919 92.5384Z",
    fill: "url(#paint6_linear_723_2277)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85259 91.7751C7.25786 90.7728 12.0066 96.2718 14.4593 104.057C16.9119 111.843 16.1397 118.967 12.7344 119.969C9.32913 120.972 4.58035 115.473 2.12771 107.687C-0.324941 99.9014 0.447315 92.7774 3.85259 91.7751Z",
    fill: "url(#paint7_linear_723_2277)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.952274 96.7286C1.52645 96.5596 3.38438 100.843 5.10209 106.296C6.8198 111.749 7.74682 116.306 7.17265 116.475C6.59847 116.644 4.74054 112.361 3.02283 106.908C1.30512 101.455 0.378101 96.8977 0.952274 96.7286Z",
    fill: "#350003"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6178 159.773C71.6951 158.717 78.5784 157.992 86.9922 158.153C95.4059 158.315 102.164 159.302 102.087 160.358C102.009 161.414 95.1261 162.139 86.7124 161.978C78.2986 161.816 71.5406 160.829 71.6178 159.773Z",
    fill: "url(#paint8_linear_723_2277)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7183 158.385C71.8516 156.563 78.7803 155.216 87.194 155.378C95.6078 155.539 102.32 157.148 102.187 158.97C102.054 160.792 95.125 162.139 86.7113 161.977C78.2975 161.815 71.5849 160.207 71.7183 158.385Z",
    fill: "url(#paint9_linear_723_2277)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6148 160.648C75.6373 160.341 80.4325 160.183 86.3252 160.296C92.2179 160.41 96.9766 160.75 96.9542 161.057C96.9317 161.365 92.1365 161.522 86.2438 161.409C80.3511 161.296 75.5923 160.955 75.6148 160.648Z",
    fill: "#150303"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.29 125.893C156.65 125.171 157.792 119.341 160.84 112.871C163.889 106.4 167.689 101.74 169.329 102.462C170.969 103.184 169.827 109.015 166.779 115.485C163.731 121.955 159.93 126.615 158.29 125.893Z",
    fill: "url(#paint10_linear_723_2277)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.136 124.946C153.306 123.7 153.483 117.445 156.531 110.975C159.58 104.504 164.345 100.269 167.175 101.515C170.005 102.76 169.828 109.015 166.779 115.486C163.731 121.956 158.966 126.191 156.136 124.946Z",
    fill: "url(#paint11_linear_723_2277)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.996 123.32C160.518 123.11 161.862 119.266 163.997 114.735C166.132 110.203 168.25 106.7 168.727 106.91C169.204 107.12 167.86 110.964 165.725 115.496C163.59 120.027 161.473 123.53 160.996 123.32Z",
    fill: "#130406"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.734 36.0955C157.806 36.7068 154.961 34.2353 152.38 30.5751C149.799 26.915 148.458 23.4522 149.386 22.8409C150.314 22.2296 153.158 24.7011 155.739 28.3613C158.321 32.0215 159.661 35.4842 158.734 36.0955Z",
    fill: "url(#paint12_linear_723_2277)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.516 36.8978C155.915 37.9527 152.524 35.8407 149.943 32.1807C147.362 28.5206 146.567 24.6984 148.168 23.6435C149.769 22.5886 153.159 24.7005 155.74 28.3606C158.322 32.0207 159.116 35.8429 157.516 36.8978Z",
    fill: "url(#paint13_linear_723_2277)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.189 33.8702C157.919 34.0481 156.234 32.1142 154.427 29.5507C152.619 26.9872 151.372 24.7649 151.642 24.587C151.912 24.4092 153.596 26.3431 155.404 28.9066C157.212 31.47 158.459 33.6923 158.189 33.8702Z",
    fill: "#340409"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.769 69.8034C106.769 74.0852 103.178 77.5563 98.7484 77.5563C94.3186 77.5563 90.7275 74.0852 90.7275 69.8034C90.7275 65.5216 94.3186 62.0505 98.7484 62.0505C103.178 62.0505 106.769 65.5216 106.769 69.8034Z",
    fill: "#6C0C14"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4695 126.453C35.4558 128.13 31.4796 126.86 28.5882 123.616C25.6969 120.372 24.9854 116.383 26.9991 114.706C29.0128 113.029 32.9891 114.299 35.8804 117.543C38.7717 120.787 39.4832 124.777 37.4695 126.453Z",
    fill: "#5B0C14"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.351 17.0826C100.351 19.6517 96.7598 21.7343 92.33 21.7343C87.9002 21.7343 84.3091 19.6517 84.3091 17.0826C84.3091 14.5135 87.9002 12.4309 92.33 12.4309C96.7598 12.4309 100.351 14.5135 100.351 17.0826Z",
    fill: "#8B0F19"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.687 115.175C149.434 117.111 148.145 120.962 144.807 123.777C141.469 126.592 137.347 127.305 135.599 125.369C133.852 123.433 135.141 119.582 138.479 116.767C141.817 113.952 145.939 113.239 147.687 115.175Z",
    fill: "#440A11"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_2277",
    x1: 54.1336,
    y1: 6.77869,
    x2: 117.268,
    y2: 156.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D0F19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23070C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_723_2277",
    x1: 37.4582,
    y1: 50.6858,
    x2: 47.1731,
    y2: 73.6575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A121D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_723_2277",
    x1: 125.837,
    y1: 21.439,
    x2: 131.485,
    y2: 29.7256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18090F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A21421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_723_2277",
    x1: 155.396,
    y1: 86.7861,
    x2: 164.521,
    y2: 90.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D0B13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_723_2277",
    x1: 78.1394,
    y1: 1.16925,
    x2: 78.6943,
    y2: 6.18609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1141F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_723_2277",
    x1: 86.7182,
    y1: 115.775,
    x2: 102.747,
    y2: 146.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15090F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#530D16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_723_2277",
    x1: 10.519,
    y1: 120.973,
    x2: 2.99283,
    y2: 91.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660C14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_723_2277",
    x1: 13.3136,
    y1: 120.151,
    x2: 5.32039,
    y2: 90.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660C14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_723_2277",
    x1: 103.561,
    y1: 159.738,
    x2: 71.5665,
    y2: 161.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24070C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C080D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_723_2277",
    x1: 103.696,
    y1: 157.881,
    x2: 71.5804,
    y2: 157.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24070C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C080D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_723_2277",
    x1: 158.103,
    y1: 125.624,
    x2: 168.719,
    y2: 102.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D080D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38080E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_723_2277",
    x1: 155.759,
    y1: 124.594,
    x2: 166.285,
    y2: 101.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D080D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38080E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_723_2277",
    x1: 148.476,
    y1: 21.7342,
    x2: 159.235,
    y2: 36.0438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600B13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_723_2277",
    x1: 147.195,
    y1: 22.5786,
    x2: 157.581,
    y2: 37.1703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600B13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg81);
export default __webpack_public_path__ + "static/media/81.b15774dc796cfed599046a536b475118.svg";
export { ForwardRef as ReactComponent };